<template>
  <div class="line-up">
    <div class="line-up__title">Line Up</div>
    <div
      class="line-up__items"
      :class="{ 'line-up__items--collapsed': !isShowMore }"
      ref="commercial"
    >
      <div
        v-for="item in commercialTvList"
        :key="`commercial-tv-${item.id}`"
        class="line-up__item"
      >
        <LineUpItem :item="item" />
      </div>
    </div>
    <div class="line-up__button-wrapper">
      <button
        type="button"
        class="line-up__button"
        :class="{ 'line-up__button--active': isShowMore }"
        @click="isShowMore = !isShowMore"
      >
        {{ isShowMore ? 'Show less' : 'Show more' }}
      </button>
    </div>
  </div>
</template>
<script>
window.$ = window.jQuery
import LineUpItem from './LineUpItem.vue'
export default {
  name: 'LineUp',
  components: {
    LineUpItem,
  },
  data() {
    return {
      isShowMore: false,
      commercialTvList: [
        {
          id: 1,
          thumbnail: `LMPB-thumbnail.jpg`,
          modelname: `LMPB`,
          link: `/product/led-signage/indoor-led/lg-magnit/LMPB007`,
          dimension: [
            {
              label: '0.78',
              link: `/product/led-signage/indoor-led/lg-magnit/LMPB007`,
            },
            {
              label: '0.93',
              link: `/product/led-signage/indoor-led/lg-magnit/LMPB009`,
            },
            {
              label: '1.25',
              link: `/product/led-signage/indoor-led/lg-magnit/LMPB012`,
            },
          ],
          features: [
            `Accurate and Vivid Color Reproduction`,
            `120 Hz In/Output`,
            `Long Range Data Transmission`,
          ],
        },
        {
          id: 2,
          thumbnail: `LAAB-thumbnail.jpg`,
          modelname: `LAAB`,
          link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LAAB136`,
          dimension: [
            {
              label: '0.78',
              link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LAAB136`,
            },
          ],
          features: [
            `Accurate and Vivid Color Reproduction`,
            `All-in-One LED Screen`,
            `Simple Installation`,
          ],
        },
        {
          id: 3,
          thumbnail: `LMEA-thumbnail.jpg`,
          modelname: `LMEA`,
          link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA009`,
          dimension: [
            {
              label: '0.94',
              link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA009`,
            },
            {
              label: '1.25',
              link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA012`,
            },
            {
              label: '1.56',
              link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA015`,
            },
          ],
          features: [
            `Accurate and Vivid Color Reproduction`,
            `Essential COB LED Technology`,
            `Slim & Lightweight Cabinet`,
          ],
        },
        {
          id: 4,
          thumbnail: `LMPA-thumbnail.jpg`,
          modelname: `LMPA`,
          link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
          dimension: [
            {
              label: '0.78',
              link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
            },
            {
              label: '0.93',
              link: `/product/led-signage/indoor-led/lg-magnit/LMPA009`,
            },
            {
              label: '1.25',
              link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA012`,
            },
          ],
          features: [
            `Accurate and Vivid Color Reproduction`,
            `ST 2110 support`,
            `Long Range Data Transmission`,
          ],
        },
        {
          id: 5,
          thumbnail: `LSAP-thumbnail.jpg`,
          modelname: `LSAP`,
          link: `/product/led-signage/indoor-led/lg-magnit/LSAP007`,
          dimension: [
            {
              label: '0.78',
              link: `/product/led-signage/indoor-led/lg-magnit/LSAP007`,
            },
            {
              label: '0.93',
              link: `/product/led-signage/indoor-led/lg-magnit/LSAP009`,
            },
            {
              label: '1.25',
              link: `/product/led-signage/indoor-led/lg-magnit/LSAP012`,
            },
          ],
          features: [
            `Accurate and Vivid Color Reproduction`,
            `Sturdy Design for Carefree Use`,
            `Megapixel HELIOS LED Processing Platform`,
          ],
        },
      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      const $commercial = window.$(this.$refs.commercial)
      this.slick = $commercial.slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: false,
        arrows: true,
        infinite: false,
        focusOnSelect: false,
        responsive: [
          {
            breakpoint: 1080, // 1080px 이하에서 slick 활성화
            settings: {
              slidesToShow: 1.3,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
            },
          },
          {
            breakpoint: 99999, // 데스크탑 구간에서는 slick 비활성
            settings: 'unslick',
          },
        ],
      })
    })
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
.line-up {
  position: relative;
  display: flex;
  flex-direction: column;
  &__title {
    font-family: 'LG EI Headline';
    font-weight: 600;
    font-size: 52px;
    text-align: center;
  }
  &__subtitle {
    font-size: 32px;
    font-weight: 400;
  }
  ::v-deep .slick-list {
    margin: 0 -20px;
  }
  ::v-deep .slick-track {
    margin-left: 0;
    margin-right: 0;
  }
  ::v-deep .slick-slide {
    margin: 0 20px;
  }
  ::v-deep .slick-arrow {
    width: 18px;
    height: 34px;
  }
  ::v-deep .slick-arrow.slick-prev {
    left: -50px;
    background-image: url(/theme/rbFront/img/w/magnit/pdp_carousel_left.png);
  }
  &__items {
    margin-top: 64px;
    gap: 40px;
    display: flex;
    flex-wrap: wrap;
    &--collapsed {
      .line-up__item:nth-child(n + 4) {
        display: none;
      }
    }
  }
  &__button-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }
  &__button {
    position: relative;
    height: 47px;
    line-height: 46px;
    border: solid 1px #000;
    background-color: #fff;
    padding: 0 60px 0 30px;
    border-radius: 23px;
    font-size: 18px;
    font-weight: 400;
    color: #121212;
    &::after {
      content: '';
      display: block;
      position: absolute;
      right: 26px;
      top: 19px;
      width: 19px;
      height: 10px;
      background-image: url('/theme/rbFront/img/w/magnit/arrow_down_button.png');
    }
    &--active {
      &::after {
        transform: rotate(180deg);
        top: 17px;
      }
    }
  }
  @media screen and (max-width: 1080px) {
    overflow: visible;
    &__title {
      padding: 0 calcQuarter(60);
      font-size: calcQuarter(108);
    }
    &__subtitle {
      padding: 0 calcQuarter(60);
      font-size: calcQuarter(64);
    }
    &__items {
      gap: calcQuarter(0);
      display: block;
      margin-left: 0;
      margin-top: calcQuarter(126);
    }
    &__item {
      margin-left: 0;
    }
    &__button-wrapper {
      display: none;
    }
    ::v-deep .slick-list {
      margin: 0 calcQuarter(30);
    }
    ::v-deep .slick-slide {
      padding: 0 calcQuarter(30);
      margin: 0 0;
    }
    ::v-deep .slick-dots {
      margin-top: calcQuarter(60);
      text-align: center;
      height: calcQuarter(24);
    }
    ::v-deep .slick-dots button {
      background-color: #727171;
      border-color: #727171;
      width: calcQuarter(24);
      height: calcQuarter(24);
      box-sizing: border-box;
    }
    ::v-deep .slick-dots .slick-active button {
      width: calcQuarter(72);
      height: calcQuarter(24);
      border-radius: 5px;
      background-color: #fd312e;
      border-color: #fd312e;
    }
  }
}
</style>
